import { useMutation, useQueryClient } from "react-query";

import { makeRequest } from "../../util";

async function disableTrackerBlocker(): Promise<void> {
  await makeRequest<string>("disable_tracker_blocker");
}

export default function useDisableTrackerBlocker(
  onSuccess: () => void,
  onError: (err: any) => void
) {
  const queryClient = useQueryClient();

  return useMutation(disableTrackerBlocker, {
    onSuccess: () => {
      void queryClient.invalidateQueries("getPublishedTrackerBlockerConfig");

      onSuccess();
    },
    onError: (err) => {
      console.error(err);
      onError(err);
    },
  });
}
